import { BetType } from '../interface/odds';

export function getBetValue(betType: BetType | undefined, value: number, wasParlay: boolean = false) {
  let betValue = value;

  // Parlayodds = myodds > 0 ? (myodds - 0.01) + 1 : abs(1 / (myodds -0.01)) + 1
  if (!wasParlay && betType === BetType.PAR && value !== -999) {
    if (value > 0) {
      betValue = Number((value - 0.01 + 1).toFixed(2));
    } else {
      betValue = Number((Math.abs(1 / (value - 0.01)) + 1).toFixed(2));
    }
  }

  return betValue;
}
